export const environment = {
    production: true,
    label: 'uat',
    API_GATEWAY_URL: 'https://uat-api.bciti.info',
};
